// What the player is CURRENTLY looking at, told to the service worker — CCT-345.
//
// ⚠️ WHY THE SERVICE WORKER HAS TO BE TOLD. A push arrives at the worker, not at the page: it has
// no idea which screen is on display, so it raised a browser notification even when the player was
// reading the very conversation the message belonged to — the message appeared in the thread AND
// interrupted them to announce itself.
//
// ⚠️ THE NOTIFICATION IS STILL RECEIVED. Only the browser POPUP is skipped: the worker still wakes
// the tabs (`cc-push`), so the badge, the notification centre and the open thread all update. What
// disappears is the duplicate, not the information.
//
// ⚠️ AND ONLY WHEN A TAB IS VISIBLE. Chrome requires a push to produce a user-visible
// notification, on pain of showing its own "This site has been updated in the background" —
// EXCEPT when a window of the origin is visible on screen, which is exactly the case this
// mechanism covers. Any other case (worker restarted and its map empty, tab in the background,
// route unknown) falls back to showing the notification: the safe default is to interrupt.

/** Declare the route displayed on screen, or `null` when leaving it. */
export function setOpenView(route: string | null): void {
  try {
    const nav: any = typeof navigator !== 'undefined' ? navigator : undefined;
    const controller = nav?.serviceWorker?.controller;
    // No controller = no worker driving this page (first load before `clients.claim`, or push
    // unsupported). Nothing to tell, and nothing suppressed: notifications keep coming.
    if (!controller) return;
    controller.postMessage({ type: 'cc-view', route: route || null });
  } catch {
    // Never throws into a screen: failing to declare a view costs one extra notification.
  }
}

// Route comparison lives in `utils/notificationRoute.sameRoute` — one definition, imported by
// whoever needs it. Duplicating it here is how the screen and the worker would start disagreeing
// on what "the same conversation" means.
